module.exports = __webpack_public_path__ + "assets/img/Record_tit.28f3cf3f.png";